"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _compositionsButtonWithIcon = _interopRequireDefault(require("@eig-builder/compositions-button-with-icon"));

var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));

var _moduleModal = _interopRequireDefault(require("@eig-builder/module-modal"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

require("../lang");

var MyImagesDeleteModal = function MyImagesDeleteModal(_ref) {
  var confirmClick = _ref.confirmClick,
      cancelClick = _ref.cancelClick,
      amountSelected = _ref.amountSelected,
      loading = _ref.loading;

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var closeFunc = function closeFunc(_ref2) {
    var type = _ref2.type;

    if (type === 'cancel') {
      cancelClick();
    } else {
      confirmClick();
    }

    setOpen(false);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_moduleModal["default"], {
    open: open,
    processing: loading,
    onClose: function onClose() {}
  }, /*#__PURE__*/_react["default"].createElement(_moduleModal["default"].Header, null, /*#__PURE__*/_react["default"].createElement(_moduleModal["default"].Header.Title, {
    title: /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
      message: "imagepicker.deleteImages.title"
    })
  })), /*#__PURE__*/_react["default"].createElement(_moduleModal["default"].Content, null, amountSelected === 1 ? /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.deleteImages.content"
  }) : /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.deleteImages.contentMultiple"
  })), /*#__PURE__*/_react["default"].createElement(_moduleModal["default"].Footer, {
    bordered: true
  }, /*#__PURE__*/_react["default"].createElement(_moduleModal["default"].Alignment, {
    rightAligned: true
  }, /*#__PURE__*/_react["default"].createElement(_moduleModal["default"].Footer.Button, {
    color: "secondary",
    dataElementLabel: "image-selector--upload--add-from-link",
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementId: "image-selector--upload--add-from-link",
    onClick: function onClick() {
      return closeFunc({
        type: 'cancel'
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.deleteImages.footerButtonNo"
  })), /*#__PURE__*/_react["default"].createElement(_moduleModal["default"].Footer.Button, {
    color: "error",
    dataElementLabel: "image-selector--upload--add-from-link",
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementId: "image-selector--upload--add-from-link",
    onClick: closeFunc
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.deleteImages.footerButtonYes"
  }))))), /*#__PURE__*/_react["default"].createElement(_compositionsButtonWithIcon["default"], {
    tag: "delete-image-from-my-images",
    labelPosition: "after",
    fullWidth: true,
    variant: "contained",
    color: "warning",
    icon: /*#__PURE__*/_react["default"].createElement(_Delete["default"], null),
    dataElementLabel: "image-selector--nav--delete-images--deletemode",
    dataElementLocation: _taggingHelper.DataElementLocations.NAV,
    dataElementId: "image-selector--nav--delete-images--deletemode",
    key: "delete-my-images",
    onClick: function onClick() {
      return setOpen(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.delete"
  }), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "\xA0(", amountSelected, ")")));
};

MyImagesDeleteModal.propTypes = {
  confirmClick: _propTypes["default"].func.isRequired,
  amountSelected: _propTypes["default"].number.isRequired,
  loading: _propTypes["default"].bool.isRequired,
  cancelClick: _propTypes["default"].func.isRequired
};
var _default = MyImagesDeleteModal;
exports["default"] = _default;